import { NgModule } from '@angular/core';
import { HighlightJsDirective } from './highlightJs.directive';
var HighlightJsModule = (function () {
    function HighlightJsModule() {
    }
    HighlightJsModule.forRoot = function (hljs) {
        return {
            ngModule: HighlightJsModule,
            providers: [hljs]
        };
    };
    HighlightJsModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [HighlightJsDirective],
                    exports: [HighlightJsDirective]
                },] },
    ];
    /** @nocollapse */
    HighlightJsModule.ctorParameters = function () { return []; };
    return HighlightJsModule;
}());
export { HighlightJsModule };
//# sourceMappingURL=highlightJs.module.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-highlight-js/dist/esm/src/highlightJs.module.js
// module id = ./node_modules/angular-highlight-js/dist/esm/src/highlightJs.module.js
// module chunks = common